/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-local-resource-dialog.vue?vue&type=template&id=b7422940&"
import script from "./add-local-resource-dialog.vue?vue&type=script&lang=js&"
export * from "./add-local-resource-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports